module.exports = __webpack_public_path__ + "assets/b5aafddfcd5986645d213804713a55c6.mp3";